"use client"; // ✅ Mark this as a Client Component

import dynamic from "next/dynamic";

// Dynamically import the HomePage and disable SSR
const HomePage = dynamic(() => import("@/app/home/homePage"), { ssr: false });

export default function HomePageWrapper({blogs, allCategory, selectedAowId}:any) {
  return <HomePage blogs={blogs} allCategory={allCategory} selectedAowId={selectedAowId}/>;
}
